import { ProductComparisonStarterComponent } from './product-comparison-starter.component';
import { runClientComponent } from '../../_common/client/client-component-runner';

runClientComponent({ ProductComparisonStarterComponent: ProductComparisonStarterComponent });
